module.exports = __webpack_public_path__ + "static/media/feifengshanicon.399df538.png";